<template>
  <q-list separator>
    <template v-if="templates.length">
      <TemplateListItem
        v-for="(template, i) in templates"
        :key="i"
        :template="template"
        @click="() => openTemplateForm(template)"
      />
    </template>

    <!-- Empty State -->
    <div v-else class="q-pa-md text-sm text-neutral-70">
      <q-linear-progress v-if="loading" indeterminate color="primary" />
      <span v-else>No templates found.</span>
    </div>
  </q-list>
</template>

<script setup>
defineProps({
  loading: { type: Boolean, default: false },
  templates: { type: Array, default: () => [] },
});

const injectedProps = inject("send-message-provider", {});

const { toggleTemplateFormDrawer } = useChatStore();

const openTemplateFormDialog = inject("open-template-form-dialog", null);

const openTemplateForm = (template) => {
  // If in floating mode and custom handler provided, use it
  if (openTemplateFormDialog) {
    openTemplateFormDialog(template);
  } else {
    // Default drawer behavior for non-floating mode
    toggleTemplateFormDrawer({
      open: true,
      props: {
        template,
        ...toRefs(injectedProps),
      },
      level: 0,
    });
  }
};
</script>
